import { render, staticRenderFns } from "./PalletEditor.vue?vue&type=template&id=1a6e1ae2&scoped=true&"
import script from "./PalletEditor.vue?vue&type=script&lang=js&"
export * from "./PalletEditor.vue?vue&type=script&lang=js&"
import style0 from "./PalletEditor.vue?vue&type=style&index=0&id=1a6e1ae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e1ae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
